import { useParams } from 'react-router-dom';
import CreateToolPage from './create-tool';

const EditTool = () => {
  const { id } = useParams();

  return <CreateToolPage toolId={id} />;
};

export default EditTool;
